import type { FC } from 'react'

import ReactSelect from '@/components/form/ReactSelect'
import { Translation } from '@/components/i18n/Translation'
import { numberFormat } from '@/util/formatters/numbers'

import { getInjuryReportStatusTextId } from '../helpers'
import { useInjuryReportsList } from '../hooks'
import { useInjuryReportsContext } from '../index.context'

const StatusSelect: FC<{ sortedStatuses: number[] }> = ({ sortedStatuses }) => {
  const { statusFilter, setStatusFilter } = useInjuryReportsContext()
  const { statusCounter } = useInjuryReportsList()

  const options = sortedStatuses.map(statusId => ({
    value: statusId,
    label: (
      <>
        <Translation id={getInjuryReportStatusTextId(statusId)} />{' '}
        <b>{numberFormat(statusCounter[statusId])}</b>
      </>
    ),
  }))

  return (
    <ReactSelect
      className="react-select"
      options={options}
      value={statusFilter}
      onChange={setStatusFilter}
    />
  )
}

export default StatusSelect
